import axios from 'axios'
import Constants from '../Plugins/Constants'

const baseDomain = Constants.baseUrl
const baseURL = `${baseDomain}` // Incase of /api/v1;

function acceptLanguage () {
  const raw = String(localStorage.getItem('lang') || 'ar')
    .toLowerCase()
    .trim()
  if (raw.startsWith('en')) return 'en'
  return 'ar'
}

// ALL DEFUALT CONFIGURATION HERE

const client = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Accept-Language': acceptLanguage()
  }
})

client.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = acceptLanguage()
  return config
})

export default client
